import type { AnswerMode } from "@ai-teach/types";

/**
 * Unset or empty resolves to mic alone: that is how every slide authored before `answerModes`
 * existed behaves, and how an app build predating the field reads any slide.
 */
export function resolveAnswerModes(answerModes: AnswerMode[] | null | undefined): AnswerMode[] {
  return answerModes && answerModes.length > 0 ? answerModes : ["mic"];
}

export function canAnswerByMic(answerModes: AnswerMode[] | null | undefined): boolean {
  return resolveAnswerModes(answerModes).includes("mic");
}

export function canAnswerByWriting(answerModes: AnswerMode[] | null | undefined): boolean {
  return resolveAnswerModes(answerModes).includes("write");
}
